export const CART_UPDATE = 'CART_UPDATE';

export const TYPE_OFFER = 'offer';
export const TYPE_ORDER = 'order';

export const STORAGE_CART = 'uffen-cart';
export const STORAGE_SUCCESS = 'uffen-success';

export const TAX = 21;